module.exports = __webpack_public_path__ + "img/icon-choose-as-day-picture.8b35e277.svg";